export interface ApprovalStepLike {
  id: string;
  status: string;
  approverId?: string;
  approver?: { id?: string; realName?: string };
}

export interface ApprovalLike {
  status: string;
  currentStep?: number;
  steps?: ApprovalStepLike[];
}

/** 只有流程当前的待处理步骤且审批人等于当前用户时，才允许显示审批动作。 */
export function getActionableApprovalStep(approval: ApprovalLike | undefined, userId: string | undefined): ApprovalStepLike | undefined {
  if (!approval || !userId || approval.status !== 'PENDING') return undefined;
  return approval.steps?.find((step, index) => {
    const atCurrentStep = approval.currentStep == null || approval.currentStep === index + 1;
    const approverId = step.approverId ?? step.approver?.id;
    return atCurrentStep && step.status === 'PENDING' && approverId === userId;
  });
}
